// eslint-disable-next-line import/prefer-default-export
export const EXPIRATION_DAYS_AMOUNT = [30, 60, 90];
